export default "__VITE_ASSET__BN52rdst__"